// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'

// 上传相关


// 上传文件历史记录列表
export function uploadTaskGetPage(data = {}) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/getPage',
    method: 'post',
    data,
  })
}
/**
 上传ZIP文件
 */
export function uploadTaskCreate(data = {}) {
  return request({
    url: '/admin/v1/vehicle/uploadTask/create',
    method: 'post',
    data,
  })
}


// 自定义标签查询
export function getTenantCustomTagList(data = {}) {
  return request({
    url: '/admin/v1/vehicle/tenantCustomTag/list',
    method: 'POST',
    data,
  })
}

// 获取城市列表
export function getAllCity(data = {}) {
  return request({
    url: '/admin/v1/vehicle/getAllCity/list',
    method: 'POST',
    data,
  })
}

// 检查租户是否开启过租赁商城
export function checkRentMallOpen(data) {
  return request({
    url: '/admin/v1/vehicle/common/config/checkRentMallOpen',
    method: 'post',
    data,
  })
}

// 检查租户是否开启新版计租配置
export function checkLeasePlanCalculateOpen(data) {
  return request({
    url: '/admin/v1/vehicle/common/checkGrayTenant',
    method: 'post',
    data,
  })
}
